import { CurrentUserI, EmployeeCategory } from '../api/users/interfaces/Users';

/**
 * La categoría del empleado, con las mismas reglas que el backend aplica al
 * aceptar el plan (tarea 06/15 de comparsa, `resolveOnboardingEmployeeCategory`).
 *
 * Desde que una `user_epp_config` solo existe si hay plan, la categoría vive en
 * dos sitios según el momento:
 *
 *   1. **`user.employeeCategory`** — el buzón donde el backend guarda lo que el
 *      admin eligió al invitar. Manda: si tiene valor es que el usuario todavía
 *      NO tiene plan (el backend lo vacía al aceptar), así que es el único dato.
 *   2. **`userEppConfig.data.employeeCategory`** — la del plan, cuando ya existe.
 *   3. **Representantes** de empresa y de partícipes → `DIRECTOR`, que es lo que
 *      el backend deriva de `represents_company` / `represents_participant` en el
 *      momento de la aceptación. Sin esto, la representante ve el tramo por
 *      defecto en la pantalla donde elige su aportación y el número le cambia
 *      justo después de aceptar.
 *
 * ⚠️ La regla es **por valor, no por existencia de config**: `currentUser.userEppConfig`
 * es la config por DEFECTO del usuario, que en un multi-cuenta puede ser su plan
 * INDIVIDUAL — existe, pero no habla de categorías de empleo. Preguntar solo
 * "¿tiene config?" se come la elección del admin justo en ese caso.
 */
export const resolveEmployeeCategory = (
	currentUser?: CurrentUserI | null
): EmployeeCategory | undefined => {
	const fromMailbox = currentUser?.user?.employeeCategory;
	if (fromMailbox) return fromMailbox;

	const fromPlan = currentUser?.userEppConfig?.data?.employeeCategory;
	if (fromPlan) return fromPlan;

	if (currentUser?.user?.representsCompany || currentUser?.user?.representsParticipant) {
		return EmployeeCategory.DIRECTOR;
	}

	return undefined;
};
